import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = ({ onContactClick }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ backgroundColor: 'rgba(10, 10, 10, 0)' }}
      animate={{ 
        backgroundColor: scrolled ? 'rgba(17, 17, 17, 0.95)' : 'rgba(10, 10, 10, 0)'
      }}
      transition={{ duration: 0.3 }}
      className="fixed top-0 left-0 right-0 z-50 px-6 py-4 backdrop-blur-sm"
    >
      <div className="max-w-8xl mx-auto flex items-center justify-between">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_sefer-istanbul/artifacts/90xvdv4m_sefer%20siyah%20back.png" 
            alt="SEFER"
            className="h-10"
          />
        </motion.div>
        
        <motion.button
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          onClick={onContactClick}
          className="border-2 border-[#C8102E] text-white bg-[#C8102E]/20 px-5 py-2 rounded-full text-sm font-semibold hover:bg-[#C8102E] hover:text-white hover:shadow-xl hover:shadow-[#C8102E]/50 transition-all duration-300 hover:scale-105"
        >
          Pitch Deck Talep Et
        </motion.button>
      </div>
    </motion.nav>
  );
};

export default Navbar;
